import PlacesSearch from '@src/components/home/PlacesSearch';
import React from 'react';

const LocationRequiredOverlay = () => {
	return (
		<div className="location-required-overlay on-category">
			<div className="inner">
				<div className="icon-container">
					<i className="fad fa-exclamation-circle"></i>
				</div>

				<div className="content-container">
					<h3>Location Required</h3>
					<p>Our products and service availability are dependent on where you are located.</p>
					<PlacesSearch isModalOpen={false} hasMyLocationButton />
				</div>
			</div>
		</div>
	);
};

export default LocationRequiredOverlay;
